import {
  AvailableSeatParams,
  BookingInfoState,
  CancelBooking,
  DataBookingSeatParams,
  DataSegmentBookingParams,
  DestroyParams,
  ListBookingCustomerType,
  ListDepartTimeType,
  LockAllSeatParams,
  MoveBookingSeatParams,
  MoveTicketParams,
  ParamsAssistBooking,
  ParamsBookingSearch,
  ParamsCheckBookingV2,
  ParamsCreateBooking,
  ParamsDriverBooking,
  ParamsFilterBooking,
  ParamsHistoryBooking,
  ParamsHolding,
  ParamsHoldingV2,
  ParamsPriceBooking,
  PrintBookingInfoParams,
  PrintBookingParams,
  UpdateLocationParams,
  getBookingByIdType,
} from '../types/booking';
import { getAxiosClientWithToken } from './index';
import { getAxiosClientWithTokenV2 } from './indexV2';

export const postHoldingTicketApi = (params: ParamsHolding) => {
  return getAxiosClientWithToken().post('/bookings/hold', params);
};
export const postHoldingTicketApiV2 = (params: ParamsHoldingV2) => {
  return getAxiosClientWithTokenV2().post('/bookings/hold', params);
};
export const checkBookingApiV2 = (params: ParamsCheckBookingV2) => {
  return getAxiosClientWithTokenV2().get('/bookings/check', { params });
};
export const getDetailScheduleBookingApiV2 = (schedule_id: number) => {
  return getAxiosClientWithTokenV2().get(`/bookings/schedule/${schedule_id}`);
};
export const getAssistBookingApiV2 = (params: ParamsAssistBooking) => {
  return getAxiosClientWithTokenV2().get(`/bookings/select-seat`, { params });
};
export const createBookingApi = (params: ParamsCreateBooking) => {
  return getAxiosClientWithToken().post(`/bookings/update`, params);
};

export const createBookingApiV2 = (params: ParamsCreateBooking) => {
  return getAxiosClientWithTokenV2().post(`/bookings/update`, params);
};

export const cancelBookingApi = (params: CancelBooking) => {
  const restClient = getAxiosClientWithTokenV2();
  return restClient.post(`/bookings/cancel`, params);
};
export const destroyHoldApi = (params: DestroyParams) => {
  const restClient = getAxiosClientWithTokenV2();
  return restClient.delete(`/bookings/destroy-hold`, { params });
};
export const updateBookingStatusApi = (params: {
  id: string;
  status: number;
  seat_number: number;
  depart_date: string;
}) => {
  const restClient = getAxiosClientWithTokenV2();
  return restClient.post(`/bookings/lock`, { ...params, status: params.status === 0 ? 'unlock' : 'lock' });
};
export const getBookingByIdApi = (params: getBookingByIdType) => {
  return getAxiosClientWithTokenV2().get(`/bookings/detail`, { params });
};
export const getBookingDetailSeatApi = (params: getBookingByIdType) => {
  return getAxiosClientWithTokenV2().get(`/bookings/detail-seat`, { params });
};
export const getBookingInfoApi = (params: BookingInfoState) => {
  return getAxiosClientWithToken().get(`/bookings`, { params });
};
export const getBookingInfoApiV2 = (params: BookingInfoState) => {
  return getAxiosClientWithTokenV2().get(`/bookings`, { params });
};
export const getBookingRenderApiV2 = (params: BookingInfoState) => {
  return getAxiosClientWithTokenV2().get(`/bookings/render`, { params });
};
export const getListDepartTimeApi = (params: ListDepartTimeType) => {
  return getAxiosClientWithToken().get(`/bookings/get-depart-time`, { params });
};
export const getListBookingCustomerApi = (params: ListBookingCustomerType) => {
  return getAxiosClientWithTokenV2().get(`/bookings/customers`, { params });
};
export const getListHistoryBookingApi = (params: ParamsHistoryBooking) => {
  return getAxiosClientWithTokenV2().get(`/bookings/history`, { params });
};
export const getFilterBookingApi = (params: ParamsFilterBooking) => {
  return getAxiosClientWithTokenV2().get(`/bookings/filter`, { params });
};
export const getBookingSearchApi = (params: ParamsBookingSearch) => {
  return getAxiosClientWithToken().get(`/bookings/search`, { params });
};
export const updateDriverBookingApi = (params: ParamsDriverBooking) => {
  return getAxiosClientWithToken().post(`/bookings/update-driver`, params);
};
export const getFilterCustomerApi = (params: any) => {
  return getAxiosClientWithToken().get(`/customer`, { params });
};
export const getPriceBookingApi = (params: ParamsPriceBooking) => {
  return getAxiosClientWithTokenV2().get(`/bookings/price`, { params });
};
export const getBookingSendMailApi = (bookingId?: any) => {
  return getAxiosClientWithTokenV2().get(`/bookings/send-mail?booking_id=${bookingId}`);
};
export const getSendMailOrderApi = (params: { ticket_code: string }) => {
  return getAxiosClientWithToken().get(`/orders/send-mail`, { params });
};
export const getBookingPrintTicketApi = (params?: any) => {
  return getAxiosClientWithToken().get(`/bookings/print-ticket`, { params });
};
export const getCodeTicketApi = (amount: number) => {
  return getAxiosClientWithToken().get(`/bookings/generate-code?amount=${amount}`);
};
export const getListStaffApi = () => {
  return getAxiosClientWithTokenV2().get(`/bookings/list-staff`);
};
export const getBookingCustomerApi = (params: any) => {
  return getAxiosClientWithToken().get(`/bookings/customers?${params}`);
};
export const lockAllSeatApi = (params: LockAllSeatParams) => {
  return getAxiosClientWithTokenV2().post(`/bookings/lock-all`, params);
};
export const unlockAllSeatApi = (params: LockAllSeatParams) => {
  return getAxiosClientWithTokenV2().post(`/bookings/unlock-all`, params);
};
export const postMoveTicketApi = (params: MoveTicketParams) => {
  return getAxiosClientWithTokenV2().post(`/bookings/move`, params);
};
export const postUpdatePickUpApi = (params: UpdateLocationParams) => {
  return getAxiosClientWithToken().post(`/bookings/update-pickup`, params);
};
export const postCheckPinCodeApi = (params: { pin_code: string }) => {
  return getAxiosClientWithToken().get(`/user/check-pin-code`, { params });
};
export const getAvailableSeatApi = (params: AvailableSeatParams) => {
  return getAxiosClientWithTokenV2().get(`/bookings/move/available-seats`, { params });
};

export const getPrintBookingApi = (params: PrintBookingParams) => {
  return getAxiosClientWithTokenV2().get(`/bookings/tickets`, { params });
};

export const getMultiPrintInfoBookingApi = (params: PrintBookingInfoParams) => {
  return getAxiosClientWithTokenV2().get(`/bookings/print-info`, { params });
};
export const getDataBookingSeatApi = (params: DataBookingSeatParams) => {
  return getAxiosClientWithTokenV2().get(`/bookings/seats`, { params });
};
export const getSegmentBookingSeatApi = (params: DataSegmentBookingParams) => {
  return getAxiosClientWithTokenV2().get(`/schedule/segments`, { params });
};
export const postMoveBookingSeatApi = (params: MoveBookingSeatParams) => {
  return getAxiosClientWithTokenV2().post(`/bookings/move`, params);
};
